import { createContext, useState, useContext, useEffect } from 'react'

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode')
    return saved === 'true'
  })

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode)
    if (darkMode) {
      document.body.classList.add('dark-mode')
      document.body.style.background = '#0f172a'
    } else {
      document.body.classList.remove('dark-mode')
      document.body.style.background = '#f8fafc'
    }
  }, [darkMode])

  const toggleDarkMode = () => setDarkMode(!darkMode)

  const themeStyles = {
    background: darkMode ? '#0f172a' : '#f8fafc',
    cardBg: darkMode ? '#1e293b' : '#fff',
    textColor: darkMode ? '#f1f5f9' : '#1e293b',
    borderColor: darkMode ? '#334155' : '#e2e8f0',
    sidebarBg: darkMode ? 'linear-gradient(135deg, #0f172a, #1e1b4b)' : 'linear-gradient(135deg, #1e3a5f, #0f2b42)',
    inputBg: darkMode ? '#334155' : '#fff',
    inputBorder: darkMode ? '#475569' : '#cbd5e1'
  }

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode, themeStyles }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)